import { Component, h } from '@stencil/core';

@Component({
  tag: 'cwru-main-nav',
  styleUrl: 'navigation.css',
  shadow: false,
})
export class MainNav {

  render() {
    return (
      <nav class="main-nav hidden-mobile">
        <cwru-cluster space="0px">
          <slot />
        </cwru-cluster>
      </nav>
    );
  }
}
